import type { PageBreadcrumbItem } from "@/components/layout/PageLayout";

/** NAVIGATION_AND_STATES.md § Breadcrumbs: `Module / Collection / Record`, max three. */
export const MAX_BREADCRUMBS = 3;

/**
 * Applies the breadcrumb rules to a template's trail:
 * - **Max three.** A longer trail keeps its first crumb (the module, the way home) and its last
 *   two (where you are and its parent), so the current place and the way up are never lost.
 * - **Every crumb except the last is a link**, and the last never is: it's where you are.
 *   A middle crumb without an `href` is a caller bug, so it's reported in development.
 */
export function applyBreadcrumbRules(items: PageBreadcrumbItem[]): PageBreadcrumbItem[] {
  if (items.length === 0) return items;
  const trimmed = items.length > MAX_BREADCRUMBS
    ? [items[0], ...items.slice(items.length - (MAX_BREADCRUMBS - 1))]
    : items;
  if (import.meta.env.DEV) {
    const unlinked = trimmed.slice(0, -1).filter((crumb) => !crumb.href).map((crumb) => crumb.label);
    if (unlinked.length > 0) {
      console.warn(`Breadcrumbs: every crumb but the last must be a link. Missing href: ${unlinked.join(", ")}`);
    }
  }
  const last = trimmed[trimmed.length - 1];
  return last.href ? [...trimmed.slice(0, -1), { ...last, href: undefined }] : trimmed;
}
